const areaPosGraduacaoList = [
  "1 - Educação",
  "2 - Artes e humanidades",
  "3 - Ciências sociais, comunicação e informação",
  "4 - Negócios, administração e direito",
  "5 - Ciências naturais, matemática e estatística",
  "6 - Computação e Tecnologias da Informação e Comunicação (TIC)",
  "7 - Engenharia, produção e construção",
  "8 - Agricultura, silvicultura, pesca e veterinária",
  "9 - Saúde e bem-estar",
  "10	- Serviços",
  "99	- Programas básicos",
];

export default areaPosGraduacaoList;
